// extracted by mini-css-extract-plugin
export var arrow = "_b-8";
export var fadeIn = "_b-1";
export var header = "_b-4";
export var image = "_b-3";
export var link = "_b-7";
export var modal = "_b-2";
export var overlay = "_b-0";
export var subtitle = "_b-6";
export var title = "_b-5";